"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceGroupingUpdate = exports.InvoiceGroupingCreate = exports.InvoiceGrouping = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ServiceEvent_1 = require("./ServiceEvent");
exports.InvoiceGrouping = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    serviceEvents: typebox_1.Type.Array(ServiceEvent_1.ServiceEvent),
    serviceGroupingID: typebox_1.Type.String({ format: 'uuid' }),
    lastReceivableID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    previousReceivableIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
    metadata: common_1.MetaData,
});
exports.InvoiceGroupingCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.InvoiceGrouping, ['id', 'serviceEvents', 'lastReceivableID', 'previousReceivableIDs', 'metadata']),
    typebox_1.Type.Object({
        serviceEventIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
        createServiceEvents: typebox_1.Type.Optional(typebox_1.Type.Array(ServiceEvent_1.ServiceEventCreate)),
    }),
]);
exports.InvoiceGroupingUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.InvoiceGrouping, ['id', 'serviceEvents', 'serviceGroupingID', 'previousReceivableIDs', 'metadata']),
    typebox_1.Type.Object({
        removeReceivableIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
        serviceEventIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
        createServiceEvents: typebox_1.Type.Optional(typebox_1.Type.Array(ServiceEvent_1.ServiceEventCreate)),
        removeServiceEventIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
    }),
]));
//# sourceMappingURL=InvoiceGrouping.js.map